var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsKeywordCloud"},[_c('Empty',{attrs:{"show":_vm.apiDataLineChart.length == 0}}),_c('div',{ref:"wordCloud",staticClass:"word-cloud"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }